import { createWebHistory, createRouter } from 'vue-router'

import IndexOverview from '@/components/IndexOverview'
import ObjectList from '@/components/lists/ObjectList'
import MonthVue from '@/components/calendar/Month'
import userRoutes from '@/components/user/routes'
import ColorPalette from '@Common/components/ColorPalette'

const routes = [
  { 
    path: '/', 
    name: 'index',
    component: IndexOverview,
    beforeEnter: (to, from, next) => {
      const { uri } = to.query
      if (uri != null && uri != '/') {
        next(false)
        router.push(uri)
      } else {
        next();
      }
    },
  },
  {
    path: '/login',
    name: 'login',
    component: IndexOverview
  },
  { 
    path: '/purchases', 
    name: 'purchases',
    component: ObjectList 
  },
  { 
    path: '/purchases/:id', 
    name: 'purchase',
    component: ObjectList,
    props: true
  },
  { 
    path: '/businesses', 
    name: 'businesses',
    component: ObjectList, 
    props: true,
  },
  { 
    path: '/businesses/:id', 
    name: 'business',
    component: ObjectList,
    props: true
  },
  { 
    path: '/categories', 
    name: 'categories',
    component: ObjectList,
    props: true,
  },
  { 
    path: '/categories/:id', 
    name: 'category',
    component: ObjectList,
    props: true
  },
  {
    path: '/purchases/:year/:month',
    name: 'monthly',
    component: MonthVue,
    props: (route) => ({year: parseInt(route.params.year), month: parseInt(route.params.month)}),
  },
  /*{
    path: '/.catchAll(.*)',
    name: 'NotFound',
    component: 'NotFoundComponent'
  },*/
  ...userRoutes,
  {
    path: '/colors',
    name: 'colors',
    component: ColorPalette,
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
